import { render, staticRenderFns } from "./main-notice-slider.vue?vue&type=template&id=45bd6cd6&scoped=true&"
import script from "./main-notice-slider.vue?vue&type=script&lang=js&"
export * from "./main-notice-slider.vue?vue&type=script&lang=js&"
import style0 from "./main-notice-slider.vue?vue&type=style&index=0&id=45bd6cd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bd6cd6",
  null
  
)

export default component.exports